import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';

const StaffToolbar = ({ 
  searchTerm, 
  onSearchChange, 
  roleFilter, 
  onRoleFilterChange, 
  statusFilter,
  onStatusFilterChange,
  onAddStaff, 
  selectedCount, 
  onBulkAction,
  totalCount 
}) => {
  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'Administrator', label: 'Administrator' },
    { value: 'Releaser', label: 'Releaser' },
    { value: 'Scanner', label: 'Scanner' },
    { value: 'Reporting', label: 'Reporting' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
  ];

  const bulkActions = [
    { value: 'activate', label: 'Activate Selected', icon: 'UserCheck' },
    { value: 'deactivate', label: 'Deactivate Selected', icon: 'UserX' },
    { value: 'delete', label: 'Delete Selected', icon: 'Trash2' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Main Toolbar Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        {/* Left Section - Search and Filters */}
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          {/* Search Input */}
          <div className="flex-1 max-w-md">
            <Input
              type="search"
              placeholder="Search staff by name, email, or ID..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>
          
          {/* Role Filter */}
          <div className="w-full sm:w-48">
            <Select
              options={roleOptions}
              value={roleFilter}
              onChange={onRoleFilterChange}
              placeholder="Filter by role"
            />
          </div>
          
          {/* Status Filter */}
          <div className="w-full sm:w-48">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={onStatusFilterChange}
              placeholder="Filter by status"
            />
          </div>
        </div>

        {/* Right Section - Add Button */}
        <div className="flex items-center gap-3">
          <Button
            variant="default"
            onClick={onAddStaff}
            iconName="Plus"
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap w-full"
          >
            Add New Staff
          </Button>
        </div>
      </div>
      {/* Stats and Bulk Actions Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4 border-t border-border">
        {/* Stats */}
        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} />
            <span>Total: {totalCount}</span>
          </div>
          {selectedCount > 0 && (
            <div className="flex items-center gap-2 text-primary">
              <Icon name="CheckSquare" size={16} />
              <span>{selectedCount} selected</span>
            </div>
          )}
        </div>

        {/* Bulk Actions */}
        {selectedCount > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground mr-2">Bulk actions:</span>
            {bulkActions?.map((action) => (
              <Button
                key={action?.value}
                variant={action?.value === 'delete' ? 'destructive' : 'outline'}
                size="sm"
                onClick={() => onBulkAction(action?.value)}
                iconName={action?.icon}
                iconPosition="left"
                iconSize={14}
              >
                {action?.label}
              </Button>
            ))}
          </div>
        )}
      </div>
      {/* Mobile Bulk Actions */}
      {selectedCount > 0 && (
        <div className="sm:hidden mt-4 pt-4 border-t border-border">
          <div className="grid grid-cols-1 gap-2">
            {bulkActions?.map((action) => (
              <Button
                key={action?.value}
                variant={action?.value === 'delete' ? 'destructive' : 'outline'}
                size="sm"
                onClick={() => onBulkAction(action?.value)}
                iconName={action?.icon}
                iconPosition="left"
                iconSize={14}
                fullWidth
              >
                {action?.label}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffToolbar;